
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Edit from "@/components/We/dialog/dialog.vue";
import { UserModule } from "@/store/modules/user";
import Uploader from "@/components/We/uploader/uploader.vue";

@Component({
    components: {
        Edit,
        Uploader,
    },
})
export default class extends Vue {
    @Prop({ default: false }) private value!: boolean;

    private form: any = {
        name: "",
        avatar: "",
        qq: "",
        email: "",
        phone: "",
    };
    private rules: object = {
        name: { required: true, message: "请输入姓名", trigger: "blur" },
    };

    @Watch("value")
    changeVal(newVal: boolean) {
        if (newVal) {
            this.form.name = UserModule.name;
            this.form.avatar = UserModule.avatar;
            this.form.qq = UserModule.qq;
            this.form.email = UserModule.email;
            this.form.phone = UserModule.phone;
            (this as any).$refs.editRef.open();
        } else {
            (this as any).$refs.editRef.close();
        }
    }

    close() {
        this.$emit("input", false);
    }

    submitForm() {
        (this as any).$refs["form"].validate(async (valid: any) => {
            if (valid) {
                let params = JSON.parse(JSON.stringify(this.form));

                if (!params.avatar) delete params.avatar;

                (this as any).$refs.editRef.isBtnLoad = true;

                const { code, msg } = await (this as any).$http.setPersonalInfo(
                    params
                );

                if (code == 1000) {
                    this.$message.success({ message: msg, duration: 2000 });
                    UserModule.GetUserInfo();
                    this.close();
                }

                (this as any).$refs.editRef.isBtnLoad = false;
            }
        });
    }
}
